import axios from "axios";
import { getToken } from "../services/Auth";

const api = axios.create({
  baseURL: process.env.REACT_APP_API_URL,
});

api.interceptors.request.use(async (config) => {
  document.getElementById("loader")?.classList.add("loader");
  const token = await getToken();
  if (token) {
    config.headers.Authorization = `Bearer ${token}`;
  }
  return config;
});

api.interceptors.response.use(
  (response) => {
    document.getElementById("loader")?.classList?.remove("loader");
    // do someting on response
    return response;
  },
  (error) => {
    // do someting on errir
    document.getElementById("loader")?.classList?.remove("loader");
    return Promise.reject(error?.response?.data); // => gives me the server resonse
  },
);

export default api;

export const api_url_estabelecimentos_image = `${process.env.REACT_APP_STATIC_URL}/estabelecimentos/`;
export const api_url_produtos_image = `${process.env.REACT_APP_STATIC_URL}/produtos/`;
export const api_url_promocoes_image = `${process.env.REACT_APP_STATIC_URL}/estabelecimentos/promocoes/`;
export const api_url_destaques_image = `${process.env.REACT_APP_STATIC_URL}/estabelecimentos/destaques/`;
export const api_url_cartoes_image = `${process.env.REACT_APP_STATIC_URL}/cartoes`;
